<template>
  <ContentfulColumns
    v-if="transformedHotels"
    :title="title"
    :titleHeadlineLevel="2"
    :columns="transformedHotels"
    :columnsPerView="4"
    :tabs="showSliderTabs"
  />
</template>

<script setup lang="ts">
const { hotelsByContinentAndCity } = useHotels();

const { t } = useI18n();
const localizedCityPath = useLocalizedCityPath();
const localizedHotelPath = useLocalizedHotelPath();

const { locations, title } = defineProps<{
  title: string;
  locations?: {
    sys?: {
      contentType?: {
        sys?: {
          id?: string;
        };
      };
    };
  };
}>();

const showSliderTabs = computed(() => {
  // By using no location (value of undefined) - all worldwide locations will be selected and the continents tab will be in place.
  return locations === undefined;
});

const transformedHotels = computed(() => {
  return Object.values(hotelsByContinentAndCity.value).flatMap((continent) =>
    Object.values(continent.cities).map((city) => {
      const firstHotel = city.hotels[0];

      return {
        title: city.title,
        tab: showSliderTabs.value ? continent.title : undefined,
        text: t("website.locationcollection.hotelspercity.count.label", {
          count: city.hotels.length,
        }),
        image: city.hotels.length > 1 ? firstHotel.heroImage : city.heroImage,
        buttonUrl:
          city.hotels.length > 1
            ? localizedCityPath(firstHotel.slug)
            : localizedHotelPath(firstHotel.slug),
        buttonText: t(
          "website.locationcollection.card.city.hotels.link.label",
          {
            count: city.hotels.length,
          },
        ),
        buttonVariant: "tertiary",
      };
    }),
  );
});
</script>
